import React from "react";
import {
	Brand1,
	Brand10,
	Brand11,
	Brand12,
	Brand13,
	Brand2,
	Brand3,
	Brand4,
	Brand5,
	Brand6,
	Brand7,
	Brand8,
	Brand9,
} from "../../constant/Index";
import { usePartnerContentQuery } from "../../store/services/PartnerService";

const Brands = () => {
	const { data, isLoading } = usePartnerContentQuery();
	let response = data?.response?.data;
	const BrandsImg = [
		{
			id: 0,
			BrandImg: Brand1,
		},
		{
			id: 1,
			BrandImg: Brand2,
		},
		{
			id: 2,
			BrandImg: Brand3,
		},
		{
			id: 3,
			BrandImg: Brand4,
		},
		{
			id: 4,
			BrandImg: Brand5,
		},
	];

	const BrandsImg2 = [
		{
			id: 5,
			BrandImg: Brand6,
		},
		{
			id: 6,
			BrandImg: Brand7,
		},
		{
			id: 7,
			BrandImg: Brand8,
		},
		{
			id: 8,
			BrandImg: Brand9,
		},
		{
			id: 9,
			BrandImg: Brand10,
		},
		{
			id: 10,
			BrandImg: Brand11,
		},
		{
			id: 11,
			BrandImg: Brand12,
		},
		{
			id: 12,
			BrandImg: Brand13,
		},
	];
	return (
		<>
			{/* <!-- Brands Sec Start Here --> */}
			<section className="brand_sec">
				<div className="container">
					<marquee style={{ display: "flex" }} direction="Left">
						{response?.map((data, index) => {
							return (
								<img
									key={data?.id}
									src={data?.icon_path}
									alt="brand-img"
									className="img-fluid"
								/>
							);
						})}
					</marquee>

					{/* <marquee
						style={{ display: "flex", marginTop: "30px" }}
						direction="Right"
					>
						{response?.map((data, index) => {
							return (
								<img
									key={data?.id}
									src={data?.icon_path}
									alt="brand-img"
									className="img-fluid"
								/>
							);
						})}
					</marquee> */}
					{/* <marquee
						style={{ display: "flex", paddingTop: "40px" }}
						direction="Right"
					>
						<img src={Brand6} alt="brand-img" className="img-fluid" />
						<img src={Brand7} alt="brand-img" className="img-fluid" />
						<img src={Brand8} alt="brand-img" className="img-fluid" />
						<img src={Brand9} alt="brand-img" className="img-fluid" />
						<img src={Brand10} alt="brand-img" className="img-fluid" />
						<img src={Brand11} alt="brand-img" className="img-fluid" />
						<img src={Brand12} alt="brand-img" className="img-fluid" />
						<img src={Brand13} alt="brand-img" className="img-fluid" />
						<img src={Brand6} alt="brand-img" className="img-fluid" />
						<img src={Brand7} alt="brand-img" className="img-fluid" />
						<img src={Brand8} alt="brand-img" className="img-fluid" />
						<img src={Brand9} alt="brand-img" className="img-fluid" />
						<img src={Brand10} alt="brand-img" className="img-fluid" />
						<img src={Brand11} alt="brand-img" className="img-fluid" />
						<img src={Brand12} alt="brand-img" className="img-fluid" />
						<img src={Brand13} alt="brand-img" className="img-fluid" />
					</marquee> */}
				</div>
			</section>
			{/* <!-- Brands Sec End Here --> */}
		</>
	);
};

export default Brands;
